export default __webpack_public_path__ + "static/objectif-lune-fa2757d68fe301c98a652330e099a553.png";